import React from 'react';
import { FaAndroid, FaDownload } from 'react-icons/fa';

import mobileAppBannerDesktop from '../../assests/img/download-mobile-banner-desktop.jpg';
import mobileAppBannerMobile from '../../assests/img/download-mobile-banner-mobile.jpg';

const APK_URL = 'http://brightstudy.in/apk/Brightstudy.apk';

function HomeAppDownload() {
  return (
    <section className="home-download" id="download-app">
      <a
        className="home-btn home-download-btn"
        href={APK_URL}
        download="Brightstudy.apk"
      >
        <picture>
          <source media="(max-width: 767px)" srcSet={mobileAppBannerMobile} />
          <img
            src={mobileAppBannerDesktop}
            alt="Brightstudy school app on parent, teacher, and student phones"
          />
        </picture>
      </a>
    </section>
  );
}

export default HomeAppDownload;
